$(function() {
	
	// Initialize Summernote
	$('.summernote').each(function() {
		if ($(this).data('height')) {
			var summerHeight = $(this).data('height');
		} else {
			var summerHeight = 200;
		}
		
		$(this).summernote({
			height: summerHeight,
			callbacks: {
        onImageUpload: function(files) {
					uploadImage(files[0], this);
        }
			},
			toolbar: [
				// [groupName, [list of button]]
				['style', ['bold', 'italic', 'underline', 'clear']],
				['font', ['superscript', 'subscript', 'fontname']],
				['fontsize', ['fontsize']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
                ['insert',['link']],
                ['emBoldStuff',['uploader']],
				['height', ['height']],
				['table'],
				['picture'],
				['video'],
				['fullscreen'],
				['codeview'],
			],
			fontNames: ['Fira Sans', 'Fira Sans Extra Condensed', 'Arial'],
			fontSizes: ['12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48'],
			fontNamesIgnoreCheck: ['Fira Sans', 'Fira Sans Extra Condensed', 'Arial']
		});
	});

	function uploadImage(file, editor) {
		data = new FormData();
		data.append("file", file);
		$.ajaxSetup({
			headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			}
		});
		$.ajax({
				url: '/admin/upload',
				cache: false,
				contentType: false,
				processData: false,
				data: data,
				type: "post",
				success: function(data) {
						console.log(data);
						var image = $('<img>').attr('src', data.linkPath);
						$(editor).summernote("insertNode", image[0]);
						// editor.insertImage(welEditable, url);
				},
				error: function(data) {
						console.log(data);
				}
		});
	}

	// Initialize smaller Summernote for front-end users
	$('.summernote-sm').each(function() {
		if ($(this).data('height')) {
			var summerHeight = $(this).data('height');
		} else {
			var summerHeight = 200;
		}

		$(this).summernote({
			height: summerHeight,
			toolbar: [
				['style', ['bold', 'italic', 'underline', 'clear']],
				['para', ['ul', 'ol']],
				['insert',['link']],
			]
		});
	});

	// Basic routing
	const routing = (function() {
		let action, formType, href, target;
		
		function route(href, target = '') {
            if(target == '_self') {
            	location.replace(href);
			} else {
                window.open(href);
			}
		}
		
		function submitForm(form) {
			form.submit();
		}
		
		$('[data-href], [data-action]').click(function() {
			action = $(this).attr('data-action');
            href   = $(this).attr("data-href");
            target = $(this).attr("data-target");
			if (action) {
				switch (action) {
					case 'delete':
						if(!confirm(deletion)) $(this.form).on('submit', function(e){ e.preventDefault(); });
						break;
					case 'add':
						formType = $(this).attr('data-form');
						event.preventDefault();
						$('.overlay').addClass('active');
						$(`[data-form="${formType}"]`).addClass('active');
						break;
					case 'close-modal':
						$('.overlay').removeClass('active');
						$(`[data-form="${formType}"]`).removeClass('active');
						break;
					case 'cancel':
						if(!confirm(cancellation)) $(this.form).on('submit', function(e){ e.preventDefault(); });
						break;
				}
			}
			else {
				route(href, target);
			}
		});
	})();

	// Confirmation Messages
	const deletion =  "Are you sure you want to delete this item?";
	const cancellation =  "Are you positive you want to cancel and process a refund minus the cancellation fee?";

	// Toggle immediate containers
	const toggler = (function() {
		let toToggle;
		$('[data-toggler-target]').click(function() {
			toToggle = $(this).attr("data-toggler-target");
			$(`[data-to-toggle="${toToggle}"]`).toggle();
			if ($(this).children('i').length > 0) {
				$(this).toggleClass('active');
				if ($(this).hasClass('active')) {
					$(this).find('i').attr('class', 'fa fa-minus');
				}
				else {
					$(this).find('i').attr('class', 'fa fa-plus');
				}
			}
		});
	})();
	
	// Single event page
	const showAllAgendas = (function() {
		const agendaCount = $('.single-event .right .agenda-item').length;
		$('.single-event .right .item').slice(2, 3).hide();
		$('.single-event .right .agenda button').click(function() {
			$('.single-event .right .item').slice(0, agendaCount).show();
		});
	})();

	// Event overview mobile nav

	let eventMenuToggle = $('.event-menu-toggle');
	let eventMenu = $('.event-menu');

	eventMenuToggle.click(function() {
			$(this).toggleClass('open');
			eventMenu.slideToggle(500);
	});

	$(window).on('resize', function() {
		var win = $(this);
		if(win.width() >= 768) {
			eventMenu.show();
		}
	});
	
	$('.price-field').change(function() {
		
		var priceTotal = 0;
		let noPaymentBtn = $('#no-payment');
		let PaymentBtn   = $('#stripe-checkout');
		
		checkoutConfig.priceTotal = priceTotal;
		
		$('.price-field:checked').each(function() {
			var cost = parseFloat($(this).data('cost'));
			var multiple_attendees = $("input[name='session_"+$(this).val() + "']");
			if(multiple_attendees.val() > 0)
			{
                cost += cost * multiple_attendees.val();
			}
			if(!isNaN(cost))
			{
                priceTotal += cost;
			}
		});

		if (priceTotal > 0) {
			PaymentBtn.show();
			noPaymentBtn.hide();
		} else {
			PaymentBtn.hide();
			noPaymentBtn.show();
		}
		
		if (checkoutConfig.bundlePrice) {
			priceTotal = checkoutConfig.bundlePrice;
		}

		var priceString = priceTotal + '.00';
		
		$('#payment-total').text(priceString);
		
		checkoutConfig.priceTotal = parseFloat(priceTotal + '00');
	});
	
	$('.edit-price-field').change(function() {
		calcDifference()
	});
	
	function calcDifference() {
		let newTotal     = 0;
		let currentTotal = parseFloat($('#previous-total-input').val());
		let noPaymentBtn = $('#no-payment');
		let PaymentBtn   = $('#stripe-checkout');
		
		checkoutConfig.newTotal = newTotal;
		
		$('.edit-price-field:checked').each(function() {
            let cost = parseFloat($(this).data('cost'));
            if(!isNaN(cost))
            {
                newTotal += cost;
            }
            let multiple_attendees = $("input[name='session_"+$(this).val() + "']");
            if(multiple_attendees.val() > 0)
            {
                newTotal += cost * multiple_attendees.val();
            }
		});
		
		if (checkoutConfig.bundlePrice) {
			newTotal = checkoutConfig.bundlePrice;
		}

		let priceString = newTotal + '.00';
		
		$('#new-total-input').val(priceString);
		$('#new-total').text(priceString);
		
		checkoutConfig.newTotal = parseFloat(newTotal + '00');
		
		let differenceInt    = parseFloat($('#new-total-input').val()) - parseFloat($('#previous-total-input').val());
		let differenceString = differenceInt + '.00';
		
		$('#difference-total-input').val(differenceInt);
		$('#difference-total').text(differenceString);
		
		checkoutConfig.priceTotal = parseFloat(differenceInt + '00');
		
		if (checkoutConfig.newTotal === 0 || checkoutConfig.priceTotal === 0) {
			noPaymentBtn.text('Submit Changes').show();
			PaymentBtn.hide();
		} else {
			noPaymentBtn.hide();
			PaymentBtn.show();
		}
	}
	
	$(document).ready(function() {
		if ($('#edit-registration-form').length) {
			calcDifference();
		}
	});

	$(document).ready(function() {
		$('#share-tab').click(function() {
			$('#share-tab').css('left', '-10%');
			$('#share-button-wrapper').css('left', '0');
		});

		$('#share-arrow').click(function() {
			$('#share-tab').css('left', '-31px');
			$('#share-button-wrapper').css('left', '-10%');
		});
	});

});